import React, { useEffect, useState } from 'react';
import { ScriptFileType } from '../../../../types/enums';
import PrepForInstallChecklistForm from './PrepForInstallChecklistForm';
import InitialContactScriptForm from './InitialContactScriptForm';
import PrepForTemplateChecklistForm from './PrepForTemplateChecklistForm';
import PostInstallCallScriptForm from './PostInstallCallScriptForm';
import { FileAttachment } from '../../../common/file-attachments/types/FileAttachment';
import Popup from 'devextreme-react/popup';
import './CallScriptComp.scss'
import ChangeOrderScriptForm from './ChangeOrderScriptForm';
import CabinetInstallerChangeOrderScriptForm from './CabinetInstallerChangeOrderScriptForm';
import CabinetInstallerScheduleMeasurmentScriptForm from './CabinetInstallerScheduleMeasurmentScriptForm';
import CabinetInstallerScheduleDeliveryScriptForm from './CabinetInstallerScheduleDeliveryScriptForm';
import PlumbingScheduleScriptForm from './PlumbingScheduleScriptForm';
interface CallScriptCompProps {
    retailOrderID: number;
    retailOrderNumber: string;
    fileName: string;
    isCheckBoxNeeded?: boolean;
    submitCallback?: () => void;
    fileType: ScriptFileType;
    fileAttachment: FileAttachment[] | null;
}

const CallScriptComp: React.FC<CallScriptCompProps> = ({
    retailOrderID,
    retailOrderNumber,
    fileName,
    isCheckBoxNeeded = true,
    submitCallback = undefined,
    fileType,
    fileAttachment }) => {
    var result = fileAttachment?.find(f => f.fileName === `${fileName}_completed.pdf`);

    let expectedForm: JSX.Element;
    const [isChecked, setIsChecked] = useState(false);

    const togglePopupVisibility = () => {
        setIsPdfPopupVisible(!isPdfPopupVisible);
    };

    const openPopup = () => {
        if (!isChecked && result == null) {
            setIsPdfPopupVisible(true);
        }
    }

    const handleCheckboxChange = (checked: boolean) => {
        setIsChecked(checked);
    };

    switch (fileType) {
        case ScriptFileType.InstallChecklist:
            expectedForm = <PrepForInstallChecklistForm
                onClosePopup={togglePopupVisibility}
                onCheckboxChange={handleCheckboxChange}
                retailOrderID={retailOrderID}
                retailOrderNumber={retailOrderNumber}
                onSubmit={submitCallback} />
            break;
        case ScriptFileType.InitialContact:
            expectedForm = <InitialContactScriptForm
                onClosePopup={togglePopupVisibility}
                onCheckboxChange={handleCheckboxChange}
                retailOrderID={retailOrderID}
                retailOrderNumber={retailOrderNumber}
                onSubmit={submitCallback} />
            break;
        case ScriptFileType.TemplateChecklist:
            expectedForm = <PrepForTemplateChecklistForm
                onClosePopup={togglePopupVisibility}
                onCheckboxChange={handleCheckboxChange}
                retailOrderID={retailOrderID}
                retailOrderNumber={retailOrderNumber}
                onSubmit={submitCallback} />
            break;
        case ScriptFileType.PostInstall:
            expectedForm = <PostInstallCallScriptForm
                onClosePopup={togglePopupVisibility}
                onCheckboxChange={handleCheckboxChange}
                retailOrderID={retailOrderID}
                retailOrderNumber={retailOrderNumber}
                onSubmit={submitCallback} />
            break;
        case ScriptFileType.ChangeOrder:
            expectedForm = <ChangeOrderScriptForm
                onClosePopup={togglePopupVisibility}
                onCheckboxChange={handleCheckboxChange}
                retailOrderID={retailOrderID}
                retailOrderNumber={retailOrderNumber}
                onSubmit={submitCallback} />
            break;
        case ScriptFileType.CabinetInstallerChangeOrder:
            expectedForm = <CabinetInstallerChangeOrderScriptForm
                onClosePopup={togglePopupVisibility}
                onCheckboxChange={handleCheckboxChange}
                retailOrderID={retailOrderID}
                retailOrderNumber={retailOrderNumber}
                onSubmit={submitCallback} />
            break;
        case ScriptFileType.CabinetInstallerScheduleMeasurement:
            expectedForm = <CabinetInstallerScheduleMeasurmentScriptForm
                onClosePopup={togglePopupVisibility}
                onCheckboxChange={handleCheckboxChange}
                retailOrderID={retailOrderID}
                retailOrderNumber={retailOrderNumber}
                onSubmit={submitCallback} />
            break;
        case ScriptFileType.CabinetInstallerScheduleDevilery:
            expectedForm = <CabinetInstallerScheduleDeliveryScriptForm
                onClosePopup={togglePopupVisibility}
                onCheckboxChange={handleCheckboxChange}
                retailOrderID={retailOrderID}
                retailOrderNumber={retailOrderNumber}
                onSubmit={submitCallback} />
            break;
        case ScriptFileType.PlumbingSchedule:
            expectedForm = <PlumbingScheduleScriptForm
                onClosePopup={togglePopupVisibility}
                onCheckboxChange={handleCheckboxChange}
                retailOrderID={retailOrderID}
                retailOrderNumber={retailOrderNumber}
                onSubmit={submitCallback} />
            break;
    }

    const renderPdfContent = () => {
        return (
            <div>
                {expectedForm}
            </div>
        );
    }

    const [isPdfPopupVisible, setIsPdfPopupVisible] = useState(false);
    const isExist = result != null || false;

    return (
        <div className={fileType === ScriptFileType.ChangeOrder ? "call-script change-order-call-script" : "call-script"}>
            <div className={isChecked ? "completed-call-script" : ""}>
                {isCheckBoxNeeded && (
                    <input type="checkbox" checked={isChecked || isExist} readOnly />
                )}
                <a onClick={openPopup}>
                    Call Script
                </a>
            </div>
            {
                !isChecked &&
                <Popup
                    title={fileName}
                    visible={isPdfPopupVisible}
                    hideOnOutsideClick={true}
                    width={1000}
                    height={740}
                    showCloseButton={true}
                    onHiding={togglePopupVisibility}
                    contentRender={renderPdfContent}>
                </Popup>
            }
        </div>
    );
};

export default CallScriptComp;